import { SelectOptionType } from '../../utils/react-table';

type CountryDto = {
    id: string;
    name: string;
    fifaCountryCode: string;
    alpha2: string;
    alpha3: string;
};

export const mapCountryToSelectOption = (countries: Array<CountryDto>): Array<SelectOptionType> => {
    return countries.map((country) => ({ value: country.id, label: country.name }));
};

export default CountryDto;
